// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IFundIdPropertyDto
 */
export interface IFundIdPropertyDto {
    /**
     * 
     * @type {string}
     * @memberof IFundIdPropertyDto
     */
    fund_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IFundIdPropertyDto
     */
    fund_state_id?: IFundIdPropertyDtoFundStateIdEnum;
}

/**
* @export
* @enum {string}
*/
export enum IFundIdPropertyDtoFundStateIdEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IFundIdPropertyDto interface.
 */
export function instanceOfIFundIdPropertyDto(value: object): value is IFundIdPropertyDto {
    return true;
}

export function IFundIdPropertyDtoFromJSON(json: any): IFundIdPropertyDto {
    return IFundIdPropertyDtoFromJSONTyped(json, false);
}

export function IFundIdPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IFundIdPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'fund_id': json['fund_id'] == null ? undefined : json['fund_id'],
        'fund_state_id': json['fund_state_id'] == null ? undefined : json['fund_state_id'],
    };
}

export function IFundIdPropertyDtoToJSON(json: any): IFundIdPropertyDto {
    return IFundIdPropertyDtoToJSONTyped(json, false);
}

export function IFundIdPropertyDtoToJSONTyped(value?: IFundIdPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fund_id': value['fund_id'],
        'fund_state_id': value['fund_state_id'],
    };
}

